import { render, staticRenderFns } from "./CaptchaVerify.vue?vue&type=template&id=1bb5ed44&"
import script from "./CaptchaVerify.vue?vue&type=script&lang=js&"
export * from "./CaptchaVerify.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaVerify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports